import translations from '../../components/location/ts/fi-FI';
import { registerLocale } from '../../components/location/localeStrings';

registerLocale('fi-FI', translations);
